import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useTaskById = (taskId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["task", taskId, tenantVal],
    queryFn: async () => {
      if (!taskId) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/task/get/${taskId}`);
      return response.data;
    },
    enabled: !!taskId,
    meta: { errorMessage: "Error fetching task" },
   
    staleTime: 1000 * 60 * 5,
  });
};